import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowAltRight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m18 12 .707-.707.707.707-.707.707zM6 13a1 1 0 1 1 0-2zm8.707-5.707 4 4-1.414 1.414-4-4zm4 5.414-4 4-1.414-1.414 4-4zM18 13H6v-2h12z" })));
}
const ArrowAltRight = forwardRef(_ArrowAltRight);
export { ArrowAltRight };
